import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Configure axios to include credentials globally
axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=not auth, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/auth/me`);
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    // Fallback: also store token for Authorization header
    if (data.access_token) {
      localStorage.setItem("gs_admin_token", data.access_token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch {}
    localStorage.removeItem("gs_admin_token");
    delete axios.defaults.headers.common["Authorization"];
    setUser(false);
  };

  // Restore token from localStorage on mount
  useEffect(() => {
    const t = localStorage.getItem("gs_admin_token");
    if (t) axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
